
window.BrevoConversationsID = import.meta.env.VITE_BREVO_CHAT_ID
window.BrevoConversations = null
export const useBrevoChat = () => {
	// Load widget on mount
	onMounted(() => {
		const script = document.createElement('script')
		script.async = true
		script.src = 'https://conversations-widget.brevo.com/brevo-conversations.js'

		script.onload = () => {
			window.BrevoConversations =
				window.BrevoConversations ||
				function () {
					;(window.BrevoConversations.q = window.BrevoConversations.q || []).push(arguments)
				}
		}

		if (document.head) {
			document.head.appendChild(script)
		}
	})

	// Destroy widget on unmount
	onBeforeUnmount(() => {
		window?.BrevoConversations('kill', true)
	})

	const openChat = () => {
		window?.BrevoConversations('openChat', true)
	}

	return { openChat }
}